<template>
  <div>
    <div class="wrapper survey-wrapper">
      <div v-if="finished">

        <Products :answers="answers" />
      </div>

      <div v-else class="question-fixer text-left" id="top">
         <div class="mx-auto px-4 pb-24 pt-7 sm:px-6 lg:px-8">
        <div class="max-w-7xl mx-auto sm:flex sm:flex-col sm:align-center">
          <img src="/logo2.png" class="block h-10 mb-6 self-center">
          <div class="flex justify-center items-center text-primary">
            <div class="mr-2 font-bold">Anfang</div>
            <div class="lade self-center">
              <div
                class="balken"
                :style="{ width: `${(currentQuestion / questions.length) * 100}%` }"
              >
                <!-- <h7> {{i}}/{{questions.length}} </h7> -->
              </div>
            </div>
            <div class="ml-2 font-bold">Ziel</div>
          </div>

        <div v-for="(q, i) in questions" :key="q.id">
          <transition name="fade">
            <div class="absoulute-fixer" v-if="currentQuestion == i">
              <SurveyQuestion
                v-model="answers[q.id]"
                :question="q"
                :answers="answers"
                @next="next"
              />

              <div class="bottom-nav flex justify-center">
                <button class="text-gray-400" v-if="i > 0" @click="prev">zurück</button>
                <button 
                  class="nex ml-8 inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-orange hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                  v-if="q.type != 'multiple'" 
                  :disabled="(q.type == 'multiselect' && q.min && q.min > (answers[q.id] || []).length) || (q.type == 'mail' && (!q.accept || !/^(([^<>()[\]\.,;:\s@]+(\.[^<>()[\]\.,;:\s@]+)*)|(.+))@(([^<>()[\]\.,;:\s@]+\.)+[^<>()[\]\.,;:\s@]{2,})$/i.test(answers[q.id].toLowerCase()) ))" 
                  @click="next">
                  weiter
                </button>
                

              </div>
            </div>
          </transition>
        </div>
      </div>
         </div>
         </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SurveyQuestion from "@/components/SurveyQuestion.vue";
import Products from "@/components/Products.vue";

export default {
  name: "Survey",
  components: {
    SurveyQuestion,
    Products,
  },
  data() {
    return {
      currentQuestion: 0,
      finished: false,
      questions: [
        {
          type: "intro"
        },
        {
          type: "text",
          id: "name",
          question: "Hey! Schön, dass du hier bist. Wie heißt du?",
          ph: "z.B. Max",
          topIcon: "/icons/Social Media/Conversation.png",
        },
        {
          type: "mail",
          id: "email",
          question: "Wie ist deine E-Mail Adresse?",
          sub:
            '[   ] Durch Ankreuzen dieses Feldes akzeptiere ich, dass meine persönlichen Daten an GloryFeel übermittelt werden, um meine persönliche Nahrungsergänzung zu erstellen.',
          ph: "max.muster@mail.de",
        },
        {
          type: "multiple",
          id: "gender",
          question: "Welches Geschlecht hast Du?",
          options: [
            {
              value: "female",
              text: "weiblich",
              topIcon: "/icons/Woman.png",
            },
            {
              value: "male",
              text: "männlich",
              topIcon: "/icons/Men.png",
            },
            {
              value: "diverse",
              text: "divers",
              topIcon: "/icons/Div.png",
            },
          ],
        },
        {
          type: "number",
          id: "age",
          question: "Wie alt bist Du?",
          ph: "z.B. 20",
        },
        {
          type: "multiple",
          id: "bias",
          question: "Wie stehst Du zu Nahrungsergänzungsmitteln {{name}}?",
          options: [
            {
              value: "informed",
              text: "Informiert",
              description: "Ich habe bereits viel Wissen zu dem Thema",
              topIcon: "/icons/Light.png",
            },
            {
              value: "curious",
              text: "Neugierig",
              description: "Ich bin interessiert und allgemein aufgeschlossen",
              topIcon: "/icons/Glass.png",
            },
            {
              value: "skeptical",
              text: "Skeptisch",
              description: "Ich zweifle an dem Nutzen und der Wirkung",
              topIcon: "/icons/Forbidden.png",
            },
          ],
        },
        {
          type: "multiple",
          id: "priorExperience",
          question: "Hast Du schon mal Nahrungsergänzungsmittel eingenommen?",
          sub: "(Vitamine, Mineralstoffe, Pflanzenextrakte oder ähnliches)",
          options: [
            {
              value: true,
              text: "Ja",
              topIcon: "/icons/Pills3.png",
            },
            {
              value: false,
              text: "Nein",
              topIcon: "/icons/Wrong2.png",
            },
          ],
        },
        {
          condition: ["priorExperience", "==", true],
          type: "multiple",
          id: "howOftenSubstitutes",
          question: "Wie häufig nimmst Du Nahrungsergänzungsmittel ein?",
          options: [
            {
              value: "rarely",
              text: "selten",
              topIcon: "/icons/Health/Pill2.png",
            },
            {
              value: "occasionally",
              text: "hin und wieder",
              topIcon: "/icons/Health/Pills.png",
            },
            {
              value: "daily",
              text: "täglich",
              topIcon: "/icons/Health/Pills3.png",
            },
          ],
        },
        {
          type: "multiple",
          id: "natureHealth",
          question: "Wie stehst du zu alternativer Naturheilkunde?",
          options: [
            {
              value: true,
              text: "Ich bin offen dafür.",
              topIcon: "/icons/Pills3.png",
            },
            {
              value: false,
              text: "Ich lehne sie grundsätzlich ab.",
              topIcon: "/icons/Wrong2.png",
            },
          ],
        },
        {
          type: "multiple",
          id: "desire",
          question:
            "Welches Bedürfnis möchtest Du mit Nahrungsergänzungsmitteln erfüllen?",
          options: [
            {
              value: "specific",
              text: "Spezielles Bedürfnis",
              description:
                "Ich habe ein bestimmtes Ziel oder einen Bedarf in meiner Ernährung",
              topIcon: "/icons/Corporate/Target.png",
            },
            {
              value: "general",
              text: "Allgemeine Gesundheit",
              description:
                "Ich möchte mein ganzheitliches Wohlbefinden stärken",
              topIcon: "/icons/Social Media/Like2.png",
            },
            {
              value: "opportunistic",
              text: "Neues entdecken",
              description:
                "Ich bin auf der Suche nach neuen Produkten oder Alternativen",
              topIcon: "/icons/Corporate/Search.png",
            },
          ],
        },
        {
          type: "multiselect",
          max: 2,
          min: 2,
          id: "fields",
          question:
            "Was ist dir wichtig {{name}}? Wähle genau zwei Bereiche aus.",
          options: [
            {
              value: "immuneSystem",
              text: "Immunsystem",
              topIcon: "/icons/imun.png",
            },
            {
              value: "energy",
              text: "Energie",
              topIcon: "/icons/Medical/Counter.png",
            },
            {
              value: "stress",
              text: "Stress",
              topIcon: "/icons/stress2.png",
            },
            {
              value: "sport",
              text: "Bewegung",
              topIcon: "/icons/fitness1.png",
            },
            {
              value: "hairAndNails",
              text: "Haare & Nägel",
              topIcon: "/icons/haare.png",
            },
            {
              value: "skin",
              text: "Haut & Anti-Aging",
              topIcon: "/icons/haut.png?v=c",
            },
            {
              value: "digestion",
              text: "Verdauung",
              topIcon: "/icons/Verdau.png",
            },
            {
              value: "bones",
              text: "Knochen & Gelenke",
              topIcon: "/icons/bones.png",
            },
            {
              value: "brain",
              text: "Gehirn",
              topIcon: "/icons/brain.png",
            },
            {
              value: "hearth",
              text: "Herz",
              topIcon: "/icons/herz.png",
            },
          ],
        },
        {
          type: "multiple",
          id: "lifestyle",
          question:
            "Ein gesunder Lebensstil ist die Grundlage für ein glückliches Leben. Wie schätzt Du deinen Lebensstil ein?",
          options: [
            {
              value: "healthy",
              text: "Gesundheitsbewusst",
              description: "Ich achte sehr auf meine Gesundheit ",
              topIcon: "/icons/smilie.png",
            },
            {
              value: "motivated",
              text: "Motiviert",
              description: "Ich möchte mehr auf mich und meinen Körper achten",
              topIcon: "/icons/mot.png",
            },
            {
              value: "unhealthy",
              text: "Ungesund",
              description:
                "Mir fällt es noch schwer auf meine Gesundeit zu achten",
              topIcon: "/icons/ill.png",
            },
          ],
        },
        {
          condition: ["fields", "includes", "immuneSystem"],
          type: "multiple",
          id: "immuneSystem__question-2",
          question:
            "Möchtest Du deine Abwehrkräfte stärken und weniger anfällig für Infekte sein?",
          sub: "Das Immunsystem schützt unseren gesamten Körper.",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "immuneSystem"],
          type: "multiple",
          id: "immuneSystem__question-1",
          question: "Fühlst Du dich gelegentlich angeschlagen und schlapp?",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "immuneSystem"],
          type: "multiple",
          id: "immuneSystem__question-3",
          question:
            "Bist Du täglich an Orten, wo sich viele Menschen aufhalten? z. B. öffentliche Verkehrsmittel.",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "energy"],
          type: "multiple",
          id: "energy__question-1",
          question: "Fühlst Du dich gelegentlich kraftlos und erschöpft? ",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "energy"],
          type: "multiple",
          id: "energy__question-2",
          question: "Hast Du manchmal Schwierigkeiten morgens aufzustehen?",
          sub: "Das Bett lässt einen häufig einfach nicht gehen.",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "energy"],
          type: "multiple",
          id: "energy__question-3",
          question:
            "Befindest Du dich gerade in einer herausfordernden Situation?",
          sub: "z. B. Prüfung, Abschlussarbeit, Wettkampfvorbereitung",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "sleep"],
          type: "multiple",
          id: "sleep__question-1",
          question:
            "Fällt es dir schwer einzuschlafen oder nachts durchzuschlafen?",
          sub:
            "Erholsame Nächte sind nicht nur wichtig für den Körper, sondern auch für die Psyche.",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "sleep"],
          type: "multiple",
          id: "sleep__question-3",
          question: "Wie viel Schlaf bekommst du normalerweise?",
          options: [
            {
              value: true,
              text: "Weniger als 7 Stunden Schlaf pro Nacht",
              topIcon: "/icons/7w.png",
            },
            {
              value: false,
              text: "7 Stunden Schlaf oder mehr pro Nacht",
              topIcon: "/icons/7.png",
            },
          ],
        },
        {
          condition: ["fields", "includes", "stress"],
          type: "multiple",
          id: "stress__question-2",
          question: "Hast Du gelegentlich einen stressigen Alltag?",
          sub: "Mit Stress umzugehen ist nicht einfach.",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "stress"],
          type: "multiple",
          id: "stress__question-1",
          question: "Fühlst Du dich manchmal überfordert?",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "stress"],
          type: "multiple",
          id: "stress__question-3",
          question: "Wie würdest Du deinen Stresspegel beschreiben?",
          options: [
            {
              value: "permanentStress",
              text: "Dauerstress",
            },
            {
              value: "nowThen",
              text: "Hin und wieder angespannt",
            },
            {
              value: "totalBalanced",
              text: "Total ausgeglichen",
            },
          ],
        },
        {
          condition: ["fields", "includes", "sport"],
          type: "multiple",
          id: "sport__question-1",
          question: "Möchtest du dich allgemein fitter fühlen?",
          sub: "Sport ist gesund, das weiß jeder!",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        /*{
                condition: ['fields', 'includes', 'sport'],
                type: 'multiple',
                id: 'sport__question-2',
                question: 'Möchtest du deine sportliche Leistungsfähigkeit steigern?',
                options: [
                    {
                        value: true,
                        text: 'Ja'
                    },
                    {
                        value: false,
                        text: 'Nein'
                    }
                ]
            }, */
        {
          condition: ["fields", "includes", "hairAndNails"],
          type: "multiple",
          id: "hairAndNails__question-1",
          question: "Hast Du manchmal brüchige oder eingerissene Nägel?",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        /*{
                condition: ['fields', 'includes', 'hairAndNails'],
                type: 'multiple',
                id: 'hairAndNails__question-2',
                question: 'Wünscht Du dir mehr Fülle und kraftvolleres Haar?',
                options: [
                    {
                        value: true,
                        text: 'Ja'
                    },
                    {
                        value: false,
                        text: 'Nein'
                    }
                ]
            },*/
        {
          condition: ["fields", "includes", "skin"],
          type: "multiple",
          id: "skin__question-1",
          question: "Möchtest Du dein Hautbild verbessern?",
          sub: "Unsere Haut ist der Spiegel der Seele.",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "skin"],
          type: "multiselect",
          id: "skin__question-2",
          question: "Was ist dir wichtig bei der Hautpflege?",
          options: [
            {
              value: "antiAgin",
              text: "Anti-Aging Wirkung",
            },
            {
              value: "moisture",
              text: "Feuchtigkeit",
            },
            {
              value: "tightening",
              text: "Hautstraffung",
            },
            {
              value: "reduceBlemishes",
              text: "Hautunreinheiten reduzieren",
            },
            {
              value: "generalCare",
              text: "Allgemeine Pflegewirkung",
            },
          ],
        },
        {
          condition: ["fields", "includes", "skin"],
          type: "multiple",
          id: "skin__question-3",
          question: "Hast du unreine Haut oder Akne?",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          condition: ["fields", "includes", "digestion"],
          type: "multiple",
          id: "digestion__question-1",
          question: "Hast Du häufig eines der folgenden Verdauungsprobleme?",
          sub: "Mehr als 3-mal in der Woche.",
          options: [
            {
              value: "flatulence",
              text: "Blähungen",
            },
            {
              value: "constipation",
              text: "Verstopfung",
            },
            {
              value: "heartburn",
              text: "Sodbrennen",
            },
            {
              value: false,
              text: "Keine",
            },
          ],
        },
        /*{
                condition: ['fields', 'includes', 'digestion'],
                type: 'multiple',
                id: 'digestion__question-2',
                question: 'Möchtest Du deine Verdauung auf natürliche Weise verbessern?',
                options: [
                    {
                        value: true,
                        text: 'Ja'
                    },
                    {
                        value: false,
                        text: 'Nein'
                    }
                ]
            }, */
        {
          condition: ["fields", "includes", "bones"],
          type: "multiple",
          id: "bones__question-1",
          question: "Hast du gelegentlich Gelenkbeschwerden?",
          sub: "Unsere Gelenke sorgen dafür, dass wir uns frei bewegen können.",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        } /*
            {
                condition: ['fields', 'includes', 'bones'],
                type: 'multiple',
                id: 'bones__question-2',
                question: 'Möchtest du die Beweglichkeit deiner Gelenke unterstützen?',
                options: [
                    {
                        value: true,
                        text: 'Ja'
                    },
                    {
                        value: false,
                        text: 'Nein'
                    }
                ]
            }, */,
        /*{
          condition: ["fields", "includes", "detox"],
          type: "multiple",
          id: "detox__question-2",
          question:
            "Möchtest Du deinen Körper aktiv bei der Reinigung anfallenden Schadstoffen unterstützen?",
          sub: "„Detox“ bedeutet den Körper zu entgiften.",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },*/
        /*{
          condition: ["fields", "includes", "detox"],
          type: "multiple",
          id: "detox__question-1",
          question:
            "Fühlst Du dich gelegentlich träge, müde und ausgelaugt obwohl Du ausreichenden Schlaf bekommst?",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },*/
        {
          condition: ["fields", "includes", "brain"],
          type: "multiple",
          id: "concentration__question-1",
          question:
            "{{name}} hast Du manchmal Schwierigkeiten dich für längere Zeit auf etwas zu konzentrieren?",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        } /*
            {
                condition: ['fields', 'includes', 'concentration'],
                type: 'multiple',
                id: 'concentration__question-2',
                question: 'Möchtest Du dein Erinnerungsvermögen verbessern?',
                options: [
                    {
                        value: true,
                        text: 'Ja'
                    },
                    {
                        value: false,
                        text: 'Nein'
                    }
                ]
            }, */ /*
            {
                condition: ['fields', 'includes', 'metabolism'],
                type: 'multiple',
                id: 'metabolism__question-1',
                question: 'Möchtest Du weniger kleine Zwischenmahlzeiten und Snacks essen?',
                options: [
                    {
                        value: true,
                        text: 'Ja'
                    },
                    {
                        value: false,
                        text: 'Nein'
                    }
                ]
            }, */,
        {
          condition: ["fields", "includes", "hearth"],
          type: "multiple",
          id: "hearth__question-1",
          question:
            "Möchtest du deine Herzfunktion natürlich unterstützen?",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          type: "multiple",
          id: "fruitConsumption",
          question: "Wie oft am Tag isst Du Obst & Gemüse?",
          options: [
            {
              value: "never",
              text: "Nie",
              topIcon: "/icons/Wrong2.png",
            },
            {
              value: "oneOrTwoDaily",
              text: "Ein- bis zweimal",
              topIcon: "/icons/bro.png",
            },
            {
              value: "threeOrMoreDaily",
              text: "Dreimal oder mehr",
              topIcon: "/icons/Bro2.png",
            },
          ],
        },
        {
          type: "multiple",
          id: "dairyConsumption",
          question:
            "Wie oft in der Woche trinkst/isst Du Milch und Milchprodukte?",
          options: [
            {
              value: "never",
              text: "Nie",
              topIcon: "/icons/Wrong2.png",
            },
            {
              value: "oneOrTwoDaily",
              text: "Ein- bis zweimal",
              topIcon: "/icons/milk.png",
            },
            {
              value: "threeOrMoreDaily",
              text: "Dreimal oder mehr",
              topIcon: "/icons/milk2.png",
            },
          ],
        },
        {
          type: "multiple",
          id: "meatConsumption",
          question: "Wie oft in der Woche isst Du Fleisch?",
          options: [
            {
              value: "never",
              text: "Nie",
              topIcon: "/icons/Wrong2.png",
            },
            {
              value: "oneOrTwoDaily",
              text: "Ein- bis zweimal",
              topIcon: "/icons/meat.png",
            },
            {
              value: "threeOrMoreDaily",
              text: "Dreimal oder mehr",
              topIcon: "/icons/meat2.png",
            },
          ],
        },
        {
          type: "multiple",
          id: "fishConsumption",
          question:
            "In einer normalen Woche: Wie oft isst Du Fisch und Meeresfrüchte?",
          options: [
            {
              value: "never",
              text: "Nie",
              topIcon: "/icons/Wrong2.png",
            },
            {
              value: "oneOrTwoWeekly",
              text: "Ein- bis zweimal",
              topIcon: "/icons/fisch.png",
            },
            {
              value: "threeOrMoreWeekly",
              text: "Dreimal oder mehr",
              topIcon: "/icons/fish2.png",
            },
          ],
        },
        {
          type: "multiselect",
          id: "diet",
          question: "Hast Du einen besonderen Ernährungsstil?",
          options: [
            {
              value: "vegetarian",
              text: "Vegetarisch",
            },
            {
              value: "vegan",
              text: "Vegan",
            },
            {
              value: "glutenFree",
              text: "Glutenfrei",
            },
            {
              value: "lactoseFree",
              text: "Laktosefrei",
            },
            {
              value: "nutFree",
              text: "Nussfrei",
            },
            {
              value: "lowCarb",
              text: "Weniger Kohlendydrate",
            },
          ],
        },
        {
          type: "multiple",
          id: "oftenAlcohol",
          question:
            "Trinkst Du häufig an drei oder mehr Tagen in der Woche alkoholische Getränke?",
          options: [
            {
              value: true,
              text: "Ja",
              topIcon: "/icons/bier.png",
            },
            {
              value: false,
              text: "Nein",
              topIcon: "/icons/Forbidden.png"
            },
          ],
        },
        {
          type: "multiple",
          id: "oftenSmoke",
          question:
            "Rauchst du?",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          type: "multiple",
          id: "sportActivity",
          question: "Wie häufig treibst Du in der Woche Sport?",
          options: [
            {
              value: "rarely",
              text: "Selten",
              topIcon: "/icons/hang.png",
            },
            {
              value: "oneToThreeWeekly",
              text: "1 bis 3-mal",
              topIcon: "/icons/hang2.png",
            },
            {
              value: "fourOrMoreWeekly",
              text: "4-mal und mehr",
              topIcon: "/icons/hang3.png",
            },
          ],
        },
        {
          condition: [
            "sportActivity",
            "includedIn",
            ["oneToThreeWeekly", "fourOrMoreWeekly"],
          ],
          type: "multiselect",
          id: "sportType",
          question: "Welche Art von Sport treibst Du?",
          options: [
            {
              value: "strength",
              text: "Kraftraining",
              description: "(z.B. Hanteltraining)",
            },
            {
              value: "stamina",
              text: "Ausdauer",
              description: "(z.B. Laufen, Fußball)",
            },
            {
              value: "relaxation",
              text: "Entspannungssport",
              description: "(z.B. Yoga, Pilates)",
            },
            {
              value: "other",
              text: "Andere Sportarten",
              description: "etwas anderes",
            },
          ],
        },
        {
          condition: [
            "sportActivity",
            "includedIn",
            ["oneToThreeWeekly", "fourOrMoreWeekly"],
          ],
          type: "multiselect",
          id: "sportGoal",
          question:
            "Was ist dir bei deinem Training wichtig? Was möchtest Du erreichen?",
          options: [
            {
              value: "stamina",
              text: "Ausdauerleistung",
            },
            {
              value: "muscleStrength",
              text: "Muskelaufbau",
            },
            {
              value: "weightLoss",
              text: "Gewichtsabnahme",
            },
            {
              value: "generalHealth",
              text: "Allgemeine Gesundheit",
            },
            {
              value: "other",
              text: "Sonstiges",
            },
          ],
        },
        {
          condition: [
            "sportActivity",
            "includedIn",
            ["oneToThreeWeekly", "fourOrMoreWeekly"],
          ],
          type: "multiselect",
          id: "sportSupport",
          question:
            "Möchtest Du Unterstützung in einem der folgenden Bereiche erhalten?",
          options: [
            {
              value: "recovery",
              text: "Regeneration",
            },
            {
              value: "fatBurning",
              text: "Fettverbrennung",
            },
            {
              value: "mobility",
              text: "Beweglichkeit ",
            },
            {
              value: "noneof",
              text: "Nichts davon",
            },
          ],
        },
        {
          type: "range",
          id: "oftenTired",
          question: "Bist Du häufig müde und antriebslos?",
          sub: "Der Alltag kann einen ganz schön auslaugen.",
          leftIcon: "/icons/7.png",
          rightIcon: "/icons/hang3.png",
        },
        {
          type: "multiple",
          id: "oftenIndoors",
          question:
            "Hältst Du dich oft in geschlossenen Räumen auf und hast wenig Möglichkeiten die Sonne zu nutzen?",
          options: [
            {
              value: true,
              text: "Ja",
              topIcon: "/icons/cloud.png",
            },
            {
              value: false,
              text: "Nein",
              topIcon: "/icons/sun.png",
            },
          ],
        },
        {
          condition: ["gender", "==", "female"],
          type: "multiple",
          id: "menstruationSufferance",
          question:
            "Liebe {{name}}, um dich noch besser kennen zu lernen, haben wir noch ein paar persönliche Fragen speziell an dich. Hast Du gelegentlich Regelbeschwerden?",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
            {
              value: "nopain",
              text: "Ich möchte keine Angabe machen",
            },
          ],
        },
        {
          condition: ["gender", "==", "female"],
          type: "multiple",
          id: "ironPrescription",
          question:
            "Hast Du die Empfehlung von einem Arzt bekommen mehr Eisen zu dir zu nehmen?",
          options: [
            {
              value: true,
              text: "Ja",
            },
            {
              value: false,
              text: "Nein",
            },
          ],
        },
        {
          type: "multiple",
          id: "knownFrom",
          question:
            "Auf eine Sache sind wir noch neugierig: Wie bist Du auf uns aufmerksam geworden?",
          options: [
            {
              value: "facebook",
              text: "Facebook",
            },
            {
              value: "instagram",
              text: "Instagram",
            },
            {
              value: "amazon",
              text: "Amazon",
            },
            {
              value: "google",
              text: "Google",
            },
            {
              value: "recommendation",
              text: "Empfehlung",
            },
            {
              value: "other",
              text: "Sonstiges",
            },
          ],
        },
        {
          condition: ["knownFrom", "==", "other"],
          type: "text",
          id: "knownFromFreetext",
          question: "Sonstiges: Wie bist Du auf uns aufmerksam geworden?",
          ph: "...",
        },
      ],
      answers: {},
    };
  },
  //Watcher um auf Fragenanfang zu springen bei nächster Frage
  watch: {
    currentQuestion() {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push ({
                "event": 'survey-question-'+this.questions[this.currentQuestion].id,
                "humanReadbleQuestion": this.questions[this.currentQuestion].question,
          })
      window.scrollTo({
        top: 200,
        left: 100,
        behavior: "smooth",
      });
    },
  },
  created() {
    this.questions.forEach((q) => {
      this.$set(this.answers, q.id, null);
    });
    if(this.$route.name == 'Products' && this.$route.query.answers){
      this.answers = JSON.parse(this.$route.query.answers)
      this.finished = true
    }
  },
  methods: {
    evalCondition(condition) {
      if (condition && Array.isArray(condition) && condition.length == 3) {
        let [key, operator, val] = condition;
        switch (operator) {
          case "==":
            return this.answers[key] == val;
          case ">":
            return this.answers[key] > val;
          case "<":
            return this.answers[key] < val;
          case ">=":
            return this.answers[key] >= val;
          case "<=":
            return this.answers[key] <= val;
          case "includes":
            return (
              Array.isArray(this.answers[key]) &&
              this.answers[key].includes(val)
            );
          case "includedIn":
            return Array.isArray(val) && val.includes(this.answers[key]);
          default:
            return true;
        }
      } else {
        return true;
      }
    },
    prev() {
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
        if (
          this.evalCondition(this.questions[this.currentQuestion].condition) !=
          true
        ) {
          this.prev();
        }
      }
    },
    next() {
      if(this.evalCondition(this.questions[this.currentQuestion].condition) == true){
      try{
          window.dataLayer = window.dataLayer || []
          let anwers = [this.answers[this.questions[this.currentQuestion].id]].flat()
          console.log({anwers})
          let anwersObj = anwers.reduce((acc,elm,idx)=>({...acc, [`anwers0${idx+1}`]: elm}), {})
          window.dataLayer.push ({
                "event": 'survey-question-'+this.questions[this.currentQuestion].id+'-answered',
                "humanReadbleQuestion": this.questions[this.currentQuestion].question,
                ...anwersObj
          })
        }catch(err){
          console.warn(err)
        }
      try{
          let currentQuestionObj = this.questions[this.currentQuestion]
          window._learnq = window._learnq || [];

          if(currentQuestionObj.id === "email" && this.answers[currentQuestionObj.id]){
          window._learnq.push(['identify', {
            '$email' : this.answers[currentQuestionObj.id]
          }])}else if(currentQuestionObj.id === "name" && this.answers[currentQuestionObj.id]){
          window._learnq.push(['identify', {
            '$first_name' : this.answers[currentQuestionObj.id]
          }])}else if(currentQuestionObj.id === "age" && this.answers[currentQuestionObj.id]){
          window._learnq.push(['identify', {
            'Birth Year' : new Date().getFullYear() - this.answers[currentQuestionObj.id]
          }])}else if(this.answers[currentQuestionObj.id]){
            window._learnq.push(['identify', {
            [`survey-question-${currentQuestionObj.id}`] : this.answers[currentQuestionObj.id],
            a: 2
          }
          ])}

          
        }catch(err){
          console.warn(err)
        }
      }
      if (this.currentQuestion < this.questions.length - 1) {
        this.currentQuestion++;
        if (
          this.evalCondition(this.questions[this.currentQuestion].condition) !=
          true
        ) {
          this.next();
        }
      } else {
        this.finished = true;
        window.dataLayer = window.dataLayer || []
          window.dataLayer.push ({
                "event": 'youguide-survey-completed'
          })
        this.$router.push({
          name: 'Products',
          query: {
            answers: JSON.stringify(this.answers)
          }
        })
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.absoulute-fixer {
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter-active {
  transition-delay: 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(60px);
}

.wrapper {
  margin: auto;
  position: relative;
}
.top-info-recs {
  margin: 0px 20px;
  margin-bottom: 10px;
}

.bottom-nav {
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 32px 0;
  justify-content: center;
}

/*
.bottom-nav button {
  background: transparent;
  border: 2px solid #002c4d;
  color: #002c4d;
  font-weight: bold;
  padding: 8px 16px;
  margin: 8px;
  display: block;
  cursor: pointer;
  font-size: 1.3em;
  border-radius: 0px;
  border-radius: 2px;
  outline: 0px;
  margin: auto;
}*/

.bottom-nav button.next {
  background: #e38531;
  color: #fff;
  border-color: #e38531;
  height: auto;
  padding: 0px 18px;
  /*box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 8px 22px 0 rgba(0, 0, 0, 0.19);*/
  border-radius: 2px;
  outline: 0px;
}

.bottom-nav button.next:hover {
  background: #e38531cc;
  color: #ffffff;
  border-color: #e38531cc;
  /*box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 8px 22px 0 rgba(0, 0, 0, 0.19);*/
  outline: 0px;
}

.bottom-nav button.prev {
  box-shadow: none;
  border: none;
  color: #707070;
  font-weight: 400;
}

.back {
  color: #707070;
  font-weight: 400;
  transform: translateY(60px);
  border: 0.5px solid;
  border-color: #707070;
  padding: 0px 18px;
  border-radius: 2px;
  outline: 0px;
  margin-top: 20px;
}

.lade {
  font-weight: 400;
  overflow: hidden;
  height: 12px;
  width: 100%;
  border-radius: 20px;
  outline: 0px;
  margin-top: 20px;
  margin-bottom: 20px;
  @apply bg-primary-100 sm:w-1/2
}

.balken {
  font-weight: 400;
  background-color: #002c4d;
  height: 12px;
  outline: 0px;
  transition: width 1s;
}

.balken h7 {
  text-align: left;
  color: #fff;
  margin: auto;
}

.rabatt {
  border: 3px solid #002c4dcc;
  border-style: dashed;
  margin: 0 15px;
  display: block;
}

.code {
  background-color: #002c4dcc;
  width: 170px;
  height: 170px;
  border: 1px solid #002c4dcc;
  text-align: center;
  border-radius: 200px;
  margin: 25px 25px;
  display: inline-block;
}

.code h1 {
  color: #fff;
  margin-top: 20px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  font-size: 50px;
}
.code h2 {
  color: #fff;
  font-size: 0.9em;
}

.rabatext {
  display: inline-block;
  width: 50%;
  height: 100%;
}

.rabatext h1 {
  font-size: 30px;
  padding: 0 0;
  margin: 0 0;
}
.rabatext span {
  color: red;
  padding: 0 0;
  margin: 0 0;
}

.bottom-nav .nex[disabled], .bottom-nav .nex[disabled]:hover{
  background-color: #686868;
  border-color: #686868;
  cursor: not-allowed;
}
</style>
